import { SectionTitle } from "@/components/molecules/SectionTitle";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRemainingHeight } from "@/lib/hooks/useRemainingHeight";
import { Loader } from "lucide-react";
import { useRef } from "react";
import { IntroductionSectionProps } from ".";



export const IntroductionSection = ({description}:IntroductionSectionProps) => {
    /* 
    * Get Remaining Height for the ScrollArea
    * This is used to calculate the height of the scroll area based on the available space in the container.
    */
    const { height: scrollAreaHeight, isLoading: isScrollCalculated, getHeight } = useRemainingHeight();
    const titleRowRef = useRef<HTMLDivElement>(null);
    const titleRowHeightWithGap = (titleRowRef.current?.offsetHeight ?? 40) + 8; // 8 is the gap between the buttons and the scroll area

    return (
        <div className="flex flex-col flex-1" ref={getHeight}>
            {(() => {
                if (isScrollCalculated) return (
                    <div className="grid h-full place-items-center">
                        <Loader className="animate-spin" />
                    </div>
                )

                return (
                    <div className="flex flex-col gap-2 grow-1">
                        <SectionTitle 
                            title="Description"
                            ref={titleRowRef}
                        />

                        <ScrollArea className="pe-4" type="always"
                            // style={{ height: scrollAreaHeight - titleRowHeightWithGap }}
                            style={{ height: "calc(100vh - 64px - 8px - 28px - 8px - 36px - 8px - 1px - 8px - 16px - 8px - 8px - 28px - 8px)", minHeight: 200 }}
                        >
                            <div className="flex flex-col gap-2">
                                {description || "No description provided"}
                            </div>
                        </ScrollArea>
                    </div>
                )
            })()}
        </div>
    )
}
